export const shieldIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17.604 3.332C12.99 4 12.075 2.833 10 1 7.925 2.833 7.01 4 2.396 3.332-.063 15.58 10 19 10 19s10.063-3.42 7.604-15.668z"/></svg>`,
  name: 'shield',
};
